export default "__VITE_ASSET__g8$6CGLv__";